// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CqY8","largestCol":"styles_largestCol__3vPZr","smallestCol":"styles_smallestCol__23EB6"};